//-------------------------------------------------------------------------------------------------- Imports
import { DeleteOutlined } from "@ant-design/icons";
import { Button, Card, Col, Row } from "antd";
import { Key, ReactNode } from "react";
import { StyleSheet } from "../StyleSheet";
import { ResponseEndCard } from "../types/common";

//-------------------------------------------------------------------------------------------------- Interfaces
interface ListAccordionItem {
    key: Key;
    title: string;
    children: ReactNode;
};

interface ListAccordionProps {
    items: Array<ResponseEndCard>;
    handleClick: Function;
};

//-------------------------------------------------------------------------------------------------- Component
const ListCardAccordion = (props: ListAccordionProps) => {
    const { items, handleClick } = props;


    return (
        <Row style={styles.mainContainer}>
            {items.map((item, index) => (
                <Card key={index} style={styles.cardStyles}>
                    <Row align={"middle"}>
                        <Col style={styles.titleContainer}>
                            <h3 style={{ color: "#757982", fontWeight: 600 }}>{"************" + item.endCard}</h3>
                        </Col>
                        <Col>
                            <Button
                            type="text"
                                icon={<DeleteOutlined />}
                                style={styles.buttonStyle}
                                onClick={() => handleClick(item)}
                            />
                        </Col>
                    </Row>
                </Card>
            ))}
        </Row>
    );
};

//-------------------------------------------------------------------------------------------------- Styles
const styles = StyleSheet.create({
    mainContainer: {
        width: "100%",
        flexDirection: "column",
    },
    cardStyles: {
        marginBottom: 15,
        boxShadow: "0px 0px 8px #00000029",
        borderRadius: 15
    },
    titleContainer: {
        flex: 1,
        display: "flex",
        height: "100%",
        alignItems: "center",
    },
    iconContainer: {
        display: "flex",
        width: 50,
        height: 50,
        alignItems: "center",
        justifyContent: "center",
    },
    iconStyles: {
        fontSize: 20,
    },
    childrenContainer: {
        display: "flex",
        width: "100%",
        marginTop: 20,
        alignItems: "center",
        justifyContent: "center",
    },
    buttonStyle: {
        fontWeight: 600,
        border: "none",
        color: "rgb(117, 121, 130)",
        backgroundColor:'transparent'
    },
});

//-------------------------------------------------------------------------------------------------- Exports
export type { ListAccordionItem };
export default ListCardAccordion;
